import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

import appleSSOIcon from 'dpl/assets/apple_sso_icon.svg';

function handleAppleSignIn(state) {
  const params = new URLSearchParams({
    client_id: window.__DPL_APPLE_CLIENT_APP_ID,
    redirect_uri: `${window.location.origin}/api/external/apple_oauth/callback.json`,
    response_type: 'code id_token',
    scope: 'name email',
    response_mode: 'form_post',
    state
  });
  const authUrl = new URL(`https://appleid.apple.com/auth/authorize?${params}`);

  window.location.href = authUrl.toString();
}
function ContinueWithAppleButton({ state, analytics }) {
  const buttonCta = 'Continue with Apple';

  function handleAppleClick() {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      ...analytics,
      button_cta: buttonCta
    });
    handleAppleSignIn(state);
  }
  return (
    <button
      type="button"
      onClick={handleAppleClick}
      className="button bg-white br1 b--gray-300 button--large center w-100 flex items-center justify-center"
    >
      <SmartImage src={appleSSOIcon} wrapperOnlyClassName="" />
      <span className="pl3 font-16 fw-medium">{buttonCta}</span>
    </button>
  );
}

ContinueWithAppleButton.propTypes = {
  state: PropTypes.string.isRequired,
  analytics: PropTypes.shape({
    view: PropTypes.string
  }).isRequired
};

export default ContinueWithAppleButton;
